import axois from "axios";
import { BaseApiService } from "./api-base";
import moment from "moment";

export class GjrApiService extends BaseApiService {
  constructor(host: string) {
    super("gjr");
    this.http = axois.create({
      baseURL: host,
    });
    this.http.interceptors.request.use((config) => {
      config.headers.Authorization = this.jwt;
      return config;
    });
  }

  gjr_get_stat(name: string) {
    const path = `${this.url}/stat`;
    const config = { params: { name } };
    return this.http.get(path, config).then((response) => response.data);
  }

  gjr_run(
    data: {
      folder?: any;
      bucket?: any;
      test_file?: any;
      test_bucket?: any;
      type?: any;
      name?: any;
      stage?: any;
      dataset?: any;
      epochs?: any;
    },
    ep = ""
  ) {
    const path = `api/${ep}/gjr/run`;
    const body = {
      in: data.folder,
      bucket: data.bucket,
      test_file: data.test_file,
      test_bucket: data.test_bucket,
      type: data.type,
      name: data.name,
      stage: data.stage,
      dataset: data.dataset,
      epochs: data.epochs,
      user: this.store.state.user.id,
    };
    return this.http.post(path, body).then((response) => response.data);
  }

  start_train(data: {
    folder: any;
    bucket: any;
    out: any;
    type: any;
    name: any;
    epochs: any;
  }) {
    return this.gjr_run(
      {
        folder: data.folder,
        dataset: data.bucket,
        bucket: data.out,
        type: data.type,
        name: data.name,
        epochs: data.epochs,
        stage: "train",
      },
      "train"
    );
  }

  start_custom_train(data: {
    folder: any;
    bucket: any;
    out: any;
    type: any;
    name: any;
    epochs: any;
  }) {
    const body = {
      name: `${data.type}.${data.name}.${moment(Date.now()).format("YYYY-MM-DD.HH-mm-ss")}.train`,
      namespace: 'dnn',
      labels: {
        'ocas.job.type': 'train',
        'ocas.job.project': 'ocas',
        'ocas.job.domain': 'text_rt',
        'ocas.net.train.enabled': 'true',
      },
      containers: [{
        image: 'reg.cov.net.ru/ocas/ds/rt/train:0.2.33',
        name: 'train',
        cpu: 3,
        memoryRequests: '6Gi',
        memoryLimits: '12Gi',
        gpu: 0,
        envs: {
          TYPE: data.type,
          IN: data.folder,
          BUCKET: data.out,
          OUT: 'luke.curl.cpu.train.test',
          BUCKET_DS: data.bucket,
          EPOCHS: String(data.epochs),
          FIRST_EPOCH_FULL_TRAIN: 'False',
          NVIDIA_VISIBLE_DEVICES: '',
          CUDA_VISIBLE_DEVICES: '',
        },
      }],
    }
    return this.http.post('api/train/gjr/job/create', body).then((response) => response.data);
  }

  start_net_test(data: {
    folder: any;
    bucket: any;
    test_file: any;
    test_bucket: any;
    type: any;
    name: any;
  }) {
    return this.gjr_run({
      folder: data.folder,
      bucket: data.bucket,
      test_file: data.test_file,
      test_bucket: data.test_bucket,
      type: data.type,
      name: data.name,
      stage: "test",
    });
  }

  start_custom_test(data: {
    folder: any;
    bucket: any;
    test_file: any;
    test_bucket: any;
    type: any;
    name: any;
  }) {
    const name = `${data.type}.${data.name}.${moment(Date.now()).format("YYYY-MM-DD.HH-mm-ss")}.test`;
    const body = {
      name,
      namespace: 'dnn',
      labels: {
        'ocas.job.type': 'test',
        'ocas.job.project': 'ocas',
        'ocas.job.domain': 'text_rt',
        'ocas.net.test.enabled': 'true',
      },
      containers: [{
        image: 'reg.cov.net.ru/ocas/ds/rt/text_rt:0.8.2',
        name: 'test',
        // cpu: 3,
        // memoryRequests: '6Gi',
        // memoryLimits: '12Gi',
        gpu: 0,
        envs: {
          NAME_TEST_RESULT: `${name}.${data.test_file}`,
          TYPE: data.type,
          IN: data.folder,
          BUCKET: data.bucket,
          CUDA_VISIBLE_DEVICES: '',
          RUN_AS_JOB: '1',
          TEST_BUCKET: data.test_bucket,
          TEST_FILE: data.test_file,
        },
      }],
    }
    return this.http.post('api/train/gjr/job/create', body).then((response) => response.data);
  }

  gjr_list(data: { stage: any }, ep = "") {
    const path = `api/${ep}/gjr/list`;
    const config = { params: data };
    return this.http.get(path, config).then((response) => response.data);
  }

  get_list_train = () => this.gjr_list({ stage: "train" }, "train");

  get_list_test = () => this.gjr_list({ stage: "test" });

  gjr_describe(data: { name: string; tail: any }, ep = "") {
    const path = `api/${ep}/gjr/describe`;
    const config = {
      params: {
        name: data.name,
        tail: data.tail || 100,
      },
    };
    return this.http.get(path, config).then((response) => response.data);
  }

  describe_train = (data: { name: any; tail: any }) =>
    this.gjr_describe(data, "train");

  describe_test = (data: { name: any; tail: any }) => this.gjr_describe(data);

  gjr_delete(data: { name: any }, ep = "") {
    const path = `api/${ep}/gjr/delete`;
    const body = data;
    return this.http.post(path, body).then((response) => response.data);
  }

  delete_train = (data: { name: any }) => this.gjr_delete(data, "train");

  delete_test = (data: { name: any }) => this.gjr_delete(data);

  gjr_delete_list(names: any, ep = "") {
    const path = `api/${ep}/gjr/delete_list`;
    const body = names;
    return this.http.post(path, body).then((response) => response.data);
  }

  delete_train_list = (names: any) => this.gjr_delete_list(names, "train");

  delete_test_list = (names: any) => this.gjr_delete_list(names);

  //#region kaldi
  async job_create(name: any, envs: any) {
    const path = `${this.url}/job/create`;
    const body = {
      containers: [
        {
          image: "reg.ocas.ai/ds/rt/kaldi-train:0.2.0",
          name: "train",
          cpu: 8,
          memoryLimits: "24Gi",
          memoryRequests: "6Gi",
          gpu: 0,
          envs,
        },
      ],
      name,
      namespace: "dev",
      labels: {
        "ocas.job.type": "train",
        "ocas.net.train.enabled": "true",
      },
    };
    return this.http.post(path, body).then((response) => response.data);
  }
  //#endregion
}
